import dayjs from "dayjs";
import endpoints from "../../lib/endpoints";
import { getRequestNew } from "../../lib/fetchClient";
import { baseUrl } from "../../lib/util";
import { getSessionsByName } from "../courseNew";

const pCourseSessionPopulate =
  "&populate[sessions][populate][slots][populate]=true";

export const getPCourseBySlug = async (params) => {
  try {
    const { slug, lang } = params;
    const url =
      baseUrl +
      endpoints.singlePCourseNew +
      pCourseSessionPopulate +
      `&filters[slug][$eq]=${slug}`;

    const courseData = await getRequestNew(url, { lang }, true, 300);

    if (Array.isArray(courseData?.data)) return courseData.data[0] || null;
    if (Array.isArray(courseData)) return courseData[0] || null;

    console.log("Unexpected p-course response:", courseData);
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPCourseMetaBySlug = async (params) => {
  try {
    const { slug, lang } = params;
    const url =
      baseUrl + endpoints.singlePCouseMeta + `&filters[slug][$eq]=${slug}`;

    const courseData = await getRequestNew(url, { lang }, true, 300);

    if (Array.isArray(courseData?.data)) return courseData.data[0] || null;
    if (Array.isArray(courseData)) return courseData[0] || null;

    console.log("Unexpected p-course meta response:", courseData);
    return null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

export const getPSessionsByName = async (params) => {
  try {
    const { slug, lang } = params;
    const url =
      baseUrl +
      endpoints.singlePCourseNew +
      pCourseSessionPopulate +
      `&filters[slug][$eq]=${slug}`;

    const response = await getRequestNew(url, { lang }, true, 300);
    const course = response?.data?.[0] || response?.[0] || response;
    const sessions = course?.sessions?.data || [];
    const today = dayjs().format("YYYY-MM-DD");

    const filteredSessions = sessions
      .filter((session) => session?.start_date)
      .filter(
        (session) =>
          dayjs(session.start_date).format("YYYY-MM-DD") > today
      )
      .sort(
        (a, b) =>
          new Date(a?.start_date).getTime() - new Date(b?.start_date).getTime()
      );

    if (filteredSessions.length > 0) {
      return {
        data: filteredSessions,
        meta: {
          pagination: {
            start: 0,
            limit: filteredSessions.length || 6,
            total: filteredSessions.length,
          },
        },
      };
    }

    const courseSessions = await getSessionsByName({ slug, lang });

    return (
      courseSessions || {
        data: [],
        meta: {
          pagination: {
            start: 0,
            limit: 0,
            total: 0,
          },
        },
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export const getPTestimonialsBySlug = async (params) => {
  try {
    const { slug, lang } = params;
    let url = baseUrl + endpoints.testimonialsOne;

    if (slug) url += `&filters[p_course][slug][$eq]=${slug}`;

    return await getRequestNew(url, { lang }, true, 300);
  } catch (error) {
    console.log(error);
  }
};
